import { useMemo } from 'react';
import { useUIConfig } from '../context/UIConfigContext';

export const useColorConfig = () => {
  const { config } = useUIConfig();
  const palette = config.palette || {};
  const colors = useMemo(() => ({
    primary: palette.primary,
    secondary: palette.secondary,
    success: palette.success,
    info: palette.info,
    warning: palette.warning,
    error: palette.error,
    textPrimary: palette.textPrimary,
    actionHover: palette.actionHover,
    backgroundPaper: palette.backgroundPaper,
    backgroundDefault: palette.backgroundDefault,
    textSecondary: palette.textSecondary,
    borderSubtle: palette.borderSubtle,
    divider: palette.divider,
    gradients: config.gradients || {},
    components: config.components || {},
  }), [palette, config.gradients, config.components]);

  return colors;
};
